import { defineStore } from "pinia";
import _ from "lodash";
import {
  FetchState,
  SearchCapability,
  SearchCapabilityState,
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
export const initialState: SearchCapabilityState = {
  fetchState: FetchState.Uninitialized,
  isEmployeeSearchEngineEnabled: false,
  isEmployerSearchEngineEnabled: false,
  isEmployerTypeAheadEnabled: false,
  isSearchEngineEnabled: false,
  isUserSearchEngineEnabled: false
};
export const useSearchCapabilityStore = defineStore("searchCapability", {
  state: () => (_.cloneDeep(initialState)),
  getters: {
    isLoaded: state => state.fetchState === FetchState.Loaded,
    isEmployeeSearchEnabled: state => state.isEmployeeSearchEngineEnabled === true,
    isEmployerSearchEnabled: state => state.isEmployerSearchEngineEnabled === true,
    isTypeAheadEnabled: state => state.isEmployerTypeAheadEnabled === true,
    isSearchEnabled: state => state.isSearchEngineEnabled === true,
    isUserSearchEnabled: state => state.isUserSearchEngineEnabled === true,
  },
  actions: {
    setFetchState (fetchState: FetchState) {
      this.fetchState = fetchState;
    },
    setSearchCapability (capability: SearchCapability) {
      this.isEmployeeSearchEngineEnabled = capability.isEmployeeSearchEngineEnabled;
      this.isEmployerSearchEngineEnabled = capability.isEmployerSearchEngineEnabled;
      this.isEmployerTypeAheadEnabled = capability.isEmployerTypeAheadEnabled;
      this.isUserSearchEngineEnabled = capability.isUserSearchEngineEnabled;
      this.isSearchEngineEnabled = capability.isSearchEngineEnabled;
    },
    loadSearchCabability () {
      if (this.fetchState !== FetchState.Uninitialized) {
        return;
      }
      this.setFetchState(FetchState.Loading);
      return UserService.getSearchCapability()
        .then(resp => {
          this.setSearchCapability(resp.data);
          this.setFetchState(FetchState.Loaded);
        })
        .catch(err => {
          this.setFetchState(FetchState.Uninitialized);
        });
    },
  }
});